import React, { SyntheticEvent } from 'react';
import ReactMarkdown from 'react-markdown';
import InputTextArea from './InputTextarea';
import { DispatchProp, connect } from 'react-redux';
import { compose } from 'react-apollo';
import { ApplicationState } from 'reducers';
import { getAdminMinioCredentials_getAdminMinioCredentials } from '@api/graphql/types';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import Input from './Input';

interface PropType {
    name: string;
    value: string | null | undefined;
    height?: string;
    placeholder?: string;
    hint?: string;
    prefix?: string;
    onChangeHandler: (value: any, name: string) => void;
}
interface ReduxProps {
    credentials: getAdminMinioCredentials_getAdminMinioCredentials | null;
}

type Props = ReduxProps & PropType & DispatchProp & InjectedIntlProps;


interface State {
    imageUrl: string;
    attachmentUrl: string;
    value: string | null | undefined;
}

class InputMarkdown extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);
        this.state = {
            imageUrl:  '',
            attachmentUrl: '',
            value: props.value,
        };
    }

    public componentWillReceiveProps(props: Props) {
        this.setState({value: props.value});
    }

    private insertImage = (e: SyntheticEvent) => {
        e.preventDefault();
        const value = `${this.props.value}\n\n![Kép](${this.state.imageUrl})`;
        this.props.onChangeHandler(value, this.props.name);
    }

    private insertAttachment = (e: SyntheticEvent) => {
        e.preventDefault();
        const value = `${this.props.value}\n\n[Csatolmány](${this.state.attachmentUrl})`;
        this.props.onChangeHandler(value, this.props.name);
    }

    public render() {
        const val = this.props.value ? this.props.value : undefined;
        const height = this.props.height || '20em';

        return (
            <>
            <div className="row">
                <div className="col-sm-9">
                    <Input type="imageselector" prefix={this.props.prefix} value={this.state.imageUrl} name="imageUrl" onChange={(value: string, name: string) => {
                        this.setState({imageUrl: value});
                    }} text={this.props.intl.formatMessage({id: 'component.InputMarkDown.image'})} />
                </div>
                <div className="col-sm-3">
                    <button className="btn btn-primary btn-block" disabled={this.state.imageUrl === ''} onClick={this.insertImage}>{this.props.intl.formatMessage({id: 'component.InputMarkDown.insert'})}</button>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-9">
                    <Input type="fileselector" prefix={this.props.prefix} value={this.state.attachmentUrl} name="attachmentUrl" onChange={(value: string, name: string) => {
                        this.setState({attachmentUrl: value});
                    }} text={this.props.intl.formatMessage({id: 'component.InputMarkDown.attachment'})} />
                </div>
                <div className="col-sm-3">
                    <button className="btn btn-primary btn-block" disabled={this.state.attachmentUrl === ''} onClick={this.insertAttachment}>{this.props.intl.formatMessage({id: 'component.InputMarkDown.insert'})}</button>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <div className=" m-t-sm m-b-sm" dangerouslySetInnerHTML={{__html: this.props.intl.formatMessage({id: 'component.InputMarkDown.tutorial'})}} />
                </div>
                <div className="col-md-6">
                    <InputTextArea
                        name={this.props.name}
                        value={this.props.value}
                        height={height}
                        placeholder={this.props.placeholder}
                        onChangeHandler={(value: any, name) => { this.props.onChangeHandler(value, name); }}
                        hint={this.props.hint}
                    />
                </div>
                <div className="col-md-6 article">
                    <ReactMarkdown source={val} />
                </div>
            </div>
            </>
        );
    }
}

const mapStateToProps = ({ file }: ApplicationState): { credentials: getAdminMinioCredentials_getAdminMinioCredentials | null } => {
    return { credentials: file.credentials };
};

export default compose(
    injectIntl,
    connect(mapStateToProps),
)(InputMarkdown);



// WEBPACK FOOTER //
// ./src/components/Form/InputMarkDown.tsx